export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_PRODUCTS_FAILURE = "FETCH_PRODUCTS_FAILURE";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";

export const FETCH_HOME_PRODUCTS = "FETCH_HOME_PRODUCTS";
export const FETCH_HOME_PRODUCTS_FAILURE = "FETCH_HOME_PRODUCTS_FAILURE";
export const FETCH_HOME_PRODUCTS_SUCCESS = "FETCH_HOME_PRODUCTS_SUCCESS";

export const FETCH_PRODUCT = "FETCH_PRODUCT";
export const FETCH_PRODUCT_FAILURE = "FETCH_PRODUCT_FAILURE";
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";

export const FETCH_WISHLIST = "FETCH_WISHLIST";
export const FETCH_WISHLIST_FAILURE = "FETCH_WISHLIST_FAILURE";
export const FETCH_WISHLIST_SUCCESS = "FETCH_WISHLIST_SUCCESS";

export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const ADD_TO_WISHLIST_FAILURE = "ADD_TO_WISHLIST_FAILURE";
export const ADD_TO_WISHLIST_SUCCESS = "ADD_TO_WISHLIST_SUCCESS";

export const REMOVE_TO_WISHLIST = "REMOVE_TO_WISHLIST";
export const REMOVE_TO_WISHLIST_FAILURE = "REMOVE_TO_WISHLIST_FAILURE";
export const REMOVE_TO_WISHLIST_SUCCESS = "REMOVE_TO_WISHLIST_SUCCESS";